module.exports = __webpack_public_path__ + "static/media/gov_data_icon.87f9cab9.svg";